import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Suspense, useMemo } from 'react';
import { SidebarScrollContainer, SidebarContainerBorder, SidebarContainerPane, SidebarBottomFixedContainer } from '@atlassian/search-dialog';
import { SITE_FILTER_TYPE_NAME, FilterUIVariant } from '../../../../../filters';
import { useCurrentProductGenericSelectedFilterCount, useGetCurrentProductFilters } from '../../../../../filters/filters-helper-functions';
import { useProductContext } from '../../../../product-router';
import { ProductStates } from '../../../../../product-state-machine/product-state-machine-types';
import { CheckboxListFilter } from './checkbox-list-filter';
import { ExtensibleFeedbackCollector } from '../../../../../feedback-collector';
import { useQuery } from '../../../../../query-context';
import { MoreFiltersLink } from '../../../../../../common/filters/more-filters';
import { useSessionUserInput } from '../../../../../user-input-provider';
import { MoreFiltersContainer } from '../../../../../../common/filters/more-filters/more-filters.styled';
var StaticSelectFilter = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/async-chunk/static-select-filter" */'./static-select-filter').then(function (_ref) {
    var StaticSelectFilter = _ref.StaticSelectFilter;
    return {
      default: StaticSelectFilter
    };
  });
});
var MultiSelectFilter = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/async-chunk/multi-select-filter" */'./multi-select-filter').then(function (_ref2) {
    var MultiSelectFilter = _ref2.MultiSelectFilter;
    return {
      default: MultiSelectFilter
    };
  });
});
export var MAX_SELECTED_SITES = 5;
var Filters = function Filters(_ref3) {
  var query = _ref3.query,
    filters = _ref3.filters,
    href = _ref3.href,
    showViewAllFiltersLink = _ref3.showViewAllFiltersLink;
  var _useSessionUserInput = useSessionUserInput(),
    resetSearchSession = _useSessionUserInput.resetSearchSession;
  var selectedFiltersCount = useCurrentProductGenericSelectedFilterCount();
  var siteFilters = filters.find(function (filter) {
    return filter['@type'] === SITE_FILTER_TYPE_NAME;
  });
  if (!!siteFilters) {
    siteFilters.filterConfig = _objectSpread(_objectSpread({}, siteFilters.filterConfig), {}, {
      hideIcon: true,
      usePreloadedOptions: true
    });
  }
  var nonSiteFilters = filters.filter(function (filter) {
    return filter['@type'] !== SITE_FILTER_TYPE_NAME;
  });
  return useMemo(function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarContainerBorder, null), /*#__PURE__*/React.createElement(SidebarContainerPane, null, /*#__PURE__*/React.createElement(SidebarScrollContainer, null, !!siteFilters && /*#__PURE__*/React.createElement(CheckboxListFilter, _extends({
      filterType: siteFilters['@type']
    }, siteFilters, {
      maxSelectable: MAX_SELECTED_SITES
    })), nonSiteFilters.map(function (nonSiteFilter) {
      switch (nonSiteFilter.uiVariant) {
        case FilterUIVariant.MULTI_SELECT:
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: null
          }, /*#__PURE__*/React.createElement(MultiSelectFilter, _extends({
            filterType: nonSiteFilter['@type']
          }, nonSiteFilter)));
        case FilterUIVariant.STATIC_SELECT:
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: null
          }, /*#__PURE__*/React.createElement(StaticSelectFilter, {
            filterType: nonSiteFilter['@type'],
            filterStore: nonSiteFilter.store,
            sectionTitle: nonSiteFilter.sectionLabel
          }));
        default:
          return /*#__PURE__*/React.createElement(CheckboxListFilter, _extends({
            filterType: nonSiteFilter['@type']
          }, nonSiteFilter));
      }
    }), !siteFilters && showViewAllFiltersLink && /*#__PURE__*/React.createElement(MoreFiltersContainer, null, /*#__PURE__*/React.createElement(MoreFiltersLink, {
      isLoading: false,
      href: href,
      query: query,
      selectedFiltersCount: selectedFiltersCount,
      onClick: resetSearchSession
    }))), /*#__PURE__*/React.createElement(SidebarBottomFixedContainer, null, /*#__PURE__*/React.createElement(ExtensibleFeedbackCollector, null))));
  }, [href, nonSiteFilters, query, resetSearchSession, selectedFiltersCount, showViewAllFiltersLink, siteFilters]);
};
export var FilterSection = function FilterSection(_ref4) {
  var _activeProduct$genera;
  var productState = _ref4.productState,
    _ref4$isPreQueryFilte = _ref4.isPreQueryFiltersEnabled,
    isPreQueryFiltersEnabled = _ref4$isPreQueryFilte === void 0 ? false : _ref4$isPreQueryFilte;
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var activeProduct = getActiveProduct();
  var productId = activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.id;
  var filters = useGetCurrentProductFilters();
  if (!productId || !filters.length) {
    return null;
  }
  var href = (activeProduct === null || activeProduct === void 0 || (_activeProduct$genera = activeProduct.generateAdvancedSearchUrl) === null || _activeProduct$genera === void 0 ? void 0 : _activeProduct$genera.call(activeProduct, query)) || '';
  var showViewAllFiltersLink = !!(activeProduct !== null && activeProduct !== void 0 && activeProduct.showViewAllFiltersLink);
  switch (productState) {
    case ProductStates.PostQueryTyping:
    case ProductStates.PostQueryLoading:
    case ProductStates.PostQuerySuccess:
    case ProductStates.PostQueryNoResult:
    case ProductStates.PostQueryError:
      return /*#__PURE__*/React.createElement(Filters, {
        query: query,
        filters: filters,
        href: href,
        showViewAllFiltersLink: showViewAllFiltersLink
      });
    case ProductStates.Invalid:
      return null;
    default:
      if (isPreQueryFiltersEnabled) {
        return /*#__PURE__*/React.createElement(Filters, {
          query: query,
          filters: filters,
          href: href,
          showViewAllFiltersLink: showViewAllFiltersLink
        });
      }
      return null;
  }
};